






















































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import UpdateEmailTemplateRequest from '@/models/EmailTemplates/UpdateEmailTemplateRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import ListUtils from '@/lib/listUtils';
import EmailTemplateViewModel from '@/models/EmailTemplates/EmailTemplateViewModel';
import EmailIntegrationTemplateDto from '@/models/EmailIntegrationTemplates/EmailIntegrationTemplateDto';

@Component({
    name: 'EmailTemplateEdit'
})
export default class extends GiganautVueDialog {
 
  public entity = new EmailTemplateViewModel();

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      const template = JSON.parse(JSON.stringify(AgencySettingsModule.currentEmailTemplate));
      this.entity.name = template.name;
      this.entity.templateId = template.templateId;
      this.entity.type = template.type;
      this.entity.updatedAt = template.updatedAt;
      this.entity.selectedEmailIntegrationTemplate = this.emailIntegrationTemplates.find((findTemplate: EmailIntegrationTemplateDto) => findTemplate.id === this.entity.templateId);
    }
  }

  @Watch('entity.selectedEmailIntegrationTemplate')
  onSelectedEmailIntegrationTemplateChanged(val: EmailIntegrationTemplateDto, oldVal: EmailIntegrationTemplateDto) {
    if (val) {
      this.entity.name = val.name;
      this.entity.templateId = val.id;
    }
  }

  get loading() {
    return AgencySettingsModule.loadingDialog;
  }

  get templateTypes() {
    return ListUtils.emailTemplateTypes();
  }

  get emailIntegrationTemplates() {
    return AgencySettingsModule.emailIntegrationTemplates;
  }

  get templates(): any {
    return []; //todo return list of send grid templates
  }

  async save() {
    if (!(this.$refs.form as any).validate()) {
      return;
    }
    const request = new UpdateEmailTemplateRequest();
    request.updatedAt = this.entity.updatedAt;
    request.name = this.entity.name;
    request.templateId = this.entity.templateId;
    request.type = this.entity.type;
    await AgencySettingsModule.editEmailTemplate(request)
    this.dialog = false;
  }
}
